import { Info } from "lucide-react";
import { ExternalLink } from "../../components/ui/Misc.js";

/**
 * Consulta MANUAL de los datos del vehículo por patente (sitio externo, gratis, sin
 * captcha y con los datos de personas ocultos). Sentinel no la automatiza: el sitio
 * prohíbe el scraping y su API sin clave rechaza el uso desde servidores.
 */
export const VEHICLE_LOOKUP_URL = "https://autoriesgo.cl/";

/**
 * Aviso discreto: con la patente, el analista puede ver marca, modelo, año y color
 * en autoriesgo.cl y agregarlos a la búsqueda (más datos = mejores resultados,
 * también en internet). La consulta la hace la persona en el sitio; nada se envía
 * desde Sentinel.
 */
export function VehicleLookupHint({ example = false }: { example?: boolean }) {
  return (
    <span className="inline-flex items-start gap-1 text-[12px] leading-snug text-subtle">
      <Info className="mt-px size-3.5 shrink-0" aria-hidden="true" />
      <span>
        ¿No sabe la marca, el modelo, el año o el color? Búsquelos con la patente en{" "}
        <ExternalLink href={VEHICLE_LOOKUP_URL} title="Sitio externo y gratuito: la consulta la hace usted allí; Sentinel no envía ni guarda nada">
          autoriesgo.cl
        </ExternalLink>{" "}
        y agréguelos{example ? " (ej.: BBCL12 toyota yaris 2018 rojo)" : " en Marca, Modelo, Año y Color"}: con más datos la búsqueda es más precisa.
      </span>
    </span>
  );
}
